import {
  ACCOUNT_MAMAGERMENT_OPTIONS,
  CATEGORY_MANAGEMENT,
  EXAMINATION_OPTIONS,
  PATIENT_MAMAGERMENT_OPTIONS,
  REPO_MANAGEMENT_OPTIONS
} from '../constants/cOptions'
import { StyledTStauts } from '../index.styled'
import { ICreateUpdateRole } from '../interfaces'
import { Checkbox, Col, Form, Row } from 'antd'
import { CheckboxChangeEvent } from 'antd/es/checkbox'
import { Disabled, Switch } from 'components/atoms'
import Input from 'components/atoms/input'
import TextArea from 'components/atoms/textArea'
import { FooterModal } from 'components/templates'
import { HeadTitle } from 'components/templates/headerNotification/index.styled'
import { SEARCH_QUERY_URL } from 'constants/query'
import { useCreateEdit, useModal, useProfile } from 'hooks'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { StyledFormModal } from 'styles/styledGlobal'

const StyledContainer = styled.div`
  overflow: auto;
  max-height: 550px;
`
const StyledCheckBox = styled(Checkbox)``

const StyledGroupCheckBox = styled(Checkbox.Group)`
  .ant-checkbox-group-item {
    display: flex;
    margin-left: 12%;
    margin-top: 5px;
    min-width: 200px;
  }
`
interface IProps {
  clinic_role?: ICreateUpdateRole
}

const AddEditRoleModal = (props: IProps) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const { clinic_role } = props
  const { userId: clinicId } = useProfile()
  const { close } = useModal()
  const { handleCreateItem, loading, handlePatchEditItem } = useCreateEdit(
    SEARCH_QUERY_URL.ClinicRole
  )
  const [checkedAll, setCheckedAll] = useState(false)
  const [checkedAllAccountManagement, setCheckedAllAccountManagement] =
    useState(false)
  const [checkedAccountManagement, setCheckedAccountManagement] = useState<
    string[]
  >([])
  const [checkedAllCategoryManagement, setCheckedAllCategoryManagement] =
    useState(false)
  const [checkedCategoryManagement, setCheckedCategoryManagement] = useState<
    string[]
  >([])
  const [checkedAllPatientManagement, setCheckedAllPatientManagement] =
    useState(false)
  const [checkedPatientManagement, setCheckedPatientManagement] = useState<
    string[]
  >([])

  const [checkedAllExamination, setCheckedAllExamination] = useState(false)
  const [checkedExamination, setCheckedExamination] = useState<string[]>([])

  const [checkedAllWarehouseManagement, setCheckedAllWarehouseManagement] =
    useState(false)
  const [checkedWarehouseManagement, setCheckedWarehouseManagement] = useState<
    string[]
  >([])

  useEffect(() => {
    setCheckedAllAccountManagement(
      checkedAccountManagement.length === ACCOUNT_MAMAGERMENT_OPTIONS.length
    )
  }, [checkedAccountManagement])
  useEffect(() => {
    const allChecked =
      checkedAllAccountManagement &&
      checkedAllCategoryManagement &&
      checkedAllPatientManagement &&
      checkedAllExamination &&
      checkedAllWarehouseManagement

    setCheckedAll(allChecked)
  }, [
    checkedAllAccountManagement,
    checkedAllCategoryManagement,
    checkedAllPatientManagement,
    checkedAllExamination,
    checkedAllWarehouseManagement,
    checkedAccountManagement,
    checkedCategoryManagement,
    checkedPatientManagement,
    checkedExamination,
    checkedWarehouseManagement
  ])
  useEffect(() => {
    setCheckedAllWarehouseManagement(
      checkedWarehouseManagement.length === REPO_MANAGEMENT_OPTIONS.length
    )
  }, [checkedWarehouseManagement])

  useEffect(() => {
    setCheckedAllPatientManagement(
      checkedPatientManagement.length === PATIENT_MAMAGERMENT_OPTIONS.length
    )
  }, [checkedPatientManagement])

  useEffect(() => {
    setCheckedAllCategoryManagement(
      checkedCategoryManagement.length === CATEGORY_MANAGEMENT.length
    )
  }, [checkedCategoryManagement])

  useEffect(() => {
    setCheckedAllExamination(
      checkedExamination.length === EXAMINATION_OPTIONS.length
    )
  }, [checkedExamination])

  const [status, setStatus] = useState<number>()
  const handleChangeStatus = (value: boolean) => {
    setStatus(value ? 2 : 1)
  }

  const handleCheckAllWarehouseManagement = (e: CheckboxChangeEvent) => {
    const isChecked = e.target.checked
    setCheckedAllWarehouseManagement(isChecked)
    setCheckedWarehouseManagement(
      isChecked ? REPO_MANAGEMENT_OPTIONS.map((option) => option.value) : []
    )
    form.setFieldsValue({
      warehouse_management: isChecked
        ? REPO_MANAGEMENT_OPTIONS.map((option) => option.value)
        : []
    })
  }
  const updateCheckedAllStatus = () => {
    const allChecked =
      checkedAllAccountManagement &&
      checkedAllCategoryManagement &&
      checkedAllPatientManagement &&
      checkedAllExamination &&
      checkedAllWarehouseManagement

    setCheckedAll(allChecked)
  }

  const handleCheckAllAccountManagement = (e: CheckboxChangeEvent) => {
    const isChecked = e.target.checked
    setCheckedAllAccountManagement(isChecked)
    setCheckedAccountManagement(
      isChecked ? ACCOUNT_MAMAGERMENT_OPTIONS.map((option) => option.value) : []
    )
    updateCheckedAllStatus()
    form.setFieldsValue({
      account_management: isChecked
        ? ACCOUNT_MAMAGERMENT_OPTIONS.map((option) => option.value)
        : []
    })
  }

  const handleCheckAllCategoryManagement = (e: CheckboxChangeEvent) => {
    const isChecked = e.target.checked
    setCheckedAllCategoryManagement(isChecked)
    setCheckedCategoryManagement(
      isChecked ? CATEGORY_MANAGEMENT.map((option) => option.value) : []
    )
    form.setFieldsValue({
      category_management: isChecked
        ? CATEGORY_MANAGEMENT.map((option) => option.value)
        : []
    })
  }

  const handleCheckAllPatientManagement = (e: CheckboxChangeEvent) => {
    const isChecked = e.target.checked
    setCheckedAllPatientManagement(isChecked)
    setCheckedPatientManagement(
      isChecked ? PATIENT_MAMAGERMENT_OPTIONS.map((option) => option.value) : []
    )
    form.setFieldsValue({
      patient_management: isChecked
        ? PATIENT_MAMAGERMENT_OPTIONS.map((option) => option.value)
        : []
    })
  }

  const handleCheckAllExamination = (e: CheckboxChangeEvent) => {
    const isChecked = e.target.checked
    setCheckedAllExamination(isChecked)
    setCheckedExamination(
      isChecked ? EXAMINATION_OPTIONS.map((option) => option.value) : []
    )
    form.setFieldsValue({
      examination: isChecked
        ? EXAMINATION_OPTIONS.map((option) => option.value)
        : []
    })
  }

  const handleCheckboxChangeAccountManagement = (checkedList: any) => {
    setCheckedAccountManagement(checkedList)
    setCheckedAllAccountManagement(
      checkedList.length === ACCOUNT_MAMAGERMENT_OPTIONS.length
    )
  }
  const handleCheckboxChangeWarehouseManagement = (checkedList: any) => {
    setCheckedWarehouseManagement(checkedList)
    setCheckedAllWarehouseManagement(
      checkedList.length === REPO_MANAGEMENT_OPTIONS.length
    )
  }
  const handleCheckboxChangeCategoryManagement = (checkedList: any) => {
    setCheckedCategoryManagement(checkedList)
    setCheckedAllCategoryManagement(
      checkedList.length === CATEGORY_MANAGEMENT.length
    )
  }
  const handleCheckboxChangePatientManagement = (checkedList: any) => {
    setCheckedPatientManagement(checkedList)
    setCheckedAllPatientManagement(
      checkedList.length === PATIENT_MAMAGERMENT_OPTIONS.length
    )
  }

  const handleCheckboxChangeExamination = (checkedList: any) => {
    setCheckedExamination(checkedList)
    setCheckedAllExamination(checkedList.length === EXAMINATION_OPTIONS.length)
  }
  const handleCheckAll = (e: CheckboxChangeEvent) => {
    const isChecked = e.target.checked
    setCheckedAll(isChecked)

    setCheckedAllAccountManagement(isChecked)
    setCheckedAccountManagement(
      isChecked ? ACCOUNT_MAMAGERMENT_OPTIONS.map((option) => option.value) : []
    )

    setCheckedAllCategoryManagement(isChecked)
    setCheckedCategoryManagement(
      isChecked ? CATEGORY_MANAGEMENT.map((option) => option.value) : []
    )

    setCheckedAllPatientManagement(isChecked)
    setCheckedPatientManagement(
      isChecked ? PATIENT_MAMAGERMENT_OPTIONS.map((option) => option.value) : []
    )

    setCheckedAllExamination(isChecked)
    setCheckedExamination(
      isChecked ? EXAMINATION_OPTIONS.map((option) => option.value) : []
    )

    setCheckedAllWarehouseManagement(isChecked)
    setCheckedWarehouseManagement(
      isChecked ? REPO_MANAGEMENT_OPTIONS.map((option) => option.value) : []
    )

    form.setFieldsValue({
      account_management: isChecked
        ? ACCOUNT_MAMAGERMENT_OPTIONS.map((option) => option.value)
        : [],
      category_management: isChecked
        ? CATEGORY_MANAGEMENT.map((option) => option.value)
        : [],
      patient_management: isChecked
        ? PATIENT_MAMAGERMENT_OPTIONS.map((option) => option.value)
        : [],
      examination: isChecked
        ? EXAMINATION_OPTIONS.map((option) => option.value)
        : [],
      warehouse_management: isChecked
        ? REPO_MANAGEMENT_OPTIONS.map((option) => option.value)
        : []
    })
  }

  const handleOnSubmit = async () => {
    const Form = await form.validateFields()
    const query = {
      clinic_id: clinicId,
      role: Form.role.trim(),
      description: Form.description || '',
      permission: {
        account_management: {},
        category_management: {},
        patient_management: {},
        examination: {},
        warehouse_management: {}
      },
      status: status || 2
    } as unknown as ICreateUpdateRole
    //acc
    if (checkedAccountManagement.includes('clinic_info')) {
      query.permission.account_management!.clinic_info = true
    }
    if (checkedAccountManagement.includes('system_config')) {
      query.permission.account_management!.system_config = true
    }
    if (checkedAccountManagement.includes('manage_user')) {
      query.permission.account_management!.manage_user = true
    }
    if (checkedAccountManagement.includes('permission')) {
      query.permission.account_management!.permission = true
    }
    //cate
    if (checkedCategoryManagement.includes('doctor')) {
      query.permission.category_management!.doctor = true
    }
    if (checkedCategoryManagement.includes('timing')) {
      query.permission.category_management!.timing = true
    }
    if (checkedCategoryManagement.includes('clinic')) {
      query.permission.category_management!.clinic = true
    }
    if (checkedCategoryManagement.includes('group')) {
      query.permission.category_management!.group = true
    }
    if (checkedCategoryManagement.includes('services')) {
      query.permission.category_management!.services = true
    }
    //patient
    if (checkedPatientManagement.includes('booking')) {
      query.permission.patient_management!.booking = true
    }
    if (checkedPatientManagement.includes('patient')) {
      query.permission.patient_management!.patient = true
    }
    if (checkedPatientManagement.includes('payment')) {
      query.permission.patient_management!.payment = true
    }
    if (checkedPatientManagement.includes('transaction')) {
      query.permission.patient_management!.transaction = true
    }
    //exam
    if (checkedExamination.includes('examination')) {
      query.permission.examination!.examination = true
    }
    //Warehouse
    if (checkedWarehouseManagement.includes('goods_receipt')) {
      query.permission.warehouse_management!.goods_receipt = true
    }
    if (checkedWarehouseManagement.includes('inventory')) {
      query.permission.warehouse_management!.inventory = true
    }
    const isUpdate = !!clinic_role?.id
    if (isUpdate) {
      query['id'] = clinic_role?.id
    }
    const httpClinicUser = isUpdate ? handlePatchEditItem : handleCreateItem
    const messageSuccess = isUpdate
      ? t('edit-role-successfully', { role: clinic_role?.role })
      : t('add-role-successfully', { role: clinic_role?.role })

    httpClinicUser(query, messageSuccess).then((res) => {
      if (res._successfully) {
        close(false)
        form.resetFields()
      }
    })
  }
  const [isAdmin, checkAdmin] = useState<boolean>(false)
  useEffect(() => {
    if (clinic_role?.role.toLowerCase() === 'sysadmin') {
      checkAdmin(true)
    }
  }, [clinic_role])
  useEffect(() => {
    if (clinic_role?.clinic_id) {
      const initialCheckedAccountManagement: string[] = []
      const initialCheckedCategoryManagement: string[] = []
      const initialCheckedPatientManagement: string[] = []
      const initialCheckedExamination: string[] = []
      const initialCheckedWarehouseManagement: string[] = []
      //account
      if (clinic_role.permission.account_management?.clinic_info) {
        initialCheckedAccountManagement.push('clinic_info')
      }
      if (clinic_role.permission.account_management?.system_config) {
        initialCheckedAccountManagement.push('system_config')
      }
      if (clinic_role.permission.account_management?.manage_user) {
        initialCheckedAccountManagement.push('manage_user')
      }
      if (clinic_role.permission.account_management?.permission) {
        initialCheckedAccountManagement.push('permission')
      }
      setCheckedAccountManagement(initialCheckedAccountManagement)
      // category
      if (clinic_role.permission.category_management?.doctor) {
        initialCheckedCategoryManagement.push('doctor')
      }
      if (clinic_role.permission.category_management?.timing) {
        initialCheckedCategoryManagement.push('timing')
      }
      if (clinic_role.permission.category_management?.group) {
        initialCheckedCategoryManagement.push('group')
      }
      if (clinic_role.permission.category_management?.clinic) {
        initialCheckedCategoryManagement.push('clinic')
      }
      if (clinic_role.permission.category_management?.services) {
        initialCheckedCategoryManagement.push('services')
      }
      setCheckedCategoryManagement(initialCheckedCategoryManagement)
      //patient
      if (clinic_role.permission.patient_management?.transaction) {
        initialCheckedPatientManagement.push('transaction')
      }
      if (clinic_role.permission.patient_management?.payment) {
        initialCheckedPatientManagement.push('payment')
      }
      if (clinic_role.permission.patient_management?.patient) {
        initialCheckedPatientManagement.push('patient')
      }
      if (clinic_role.permission.patient_management?.booking) {
        initialCheckedPatientManagement.push('booking')
      }
      setCheckedPatientManagement(initialCheckedPatientManagement)
      //exam
      if (clinic_role.permission.examination?.examination) {
        initialCheckedExamination.push('examination')
      }
      setCheckedExamination(initialCheckedExamination)
      //Warehouse
      if (clinic_role.permission.warehouse_management?.inventory) {
        initialCheckedWarehouseManagement.push('inventory')
      }
      if (clinic_role.permission.warehouse_management?.goods_receipt) {
        initialCheckedWarehouseManagement.push('goods_receipt')
      }
      setCheckedWarehouseManagement(initialCheckedWarehouseManagement)
      const allAccountManagementChecked =
        initialCheckedAccountManagement.length ===
        ACCOUNT_MAMAGERMENT_OPTIONS.length

      const allCategoryManagementChecked =
        initialCheckedCategoryManagement.length === CATEGORY_MANAGEMENT.length

      const allPatientManagementChecked =
        initialCheckedPatientManagement.length ===
        PATIENT_MAMAGERMENT_OPTIONS.length

      const allExaminationChecked =
        initialCheckedExamination.length === EXAMINATION_OPTIONS.length

      const allWarehouseManagementChecked =
        initialCheckedWarehouseManagement.length ===
        REPO_MANAGEMENT_OPTIONS.length

      setCheckedAll(
        allAccountManagementChecked &&
          allCategoryManagementChecked &&
          allPatientManagementChecked &&
          allExaminationChecked &&
          allWarehouseManagementChecked
      )
      setStatus(clinic_role.status === 2 ? 2 : 1)
      form.setFieldsValue({
        role: clinic_role.role,
        description: clinic_role.description,
        status: clinic_role.status === 2,
        account_management: initialCheckedAccountManagement,
        category_management: initialCheckedCategoryManagement,
        patient_management: initialCheckedPatientManagement,
        examination: initialCheckedExamination,
        warehouse_management: initialCheckedWarehouseManagement
      })
    } else
      form.setFieldsValue({
        status: true
      })
  }, [clinic_role])

  return (
    <Disabled disabled={loading}>
      <StyledContainer>
        <StyledFormModal form={form} validateTrigger={['onChange']}>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="role"
                validateTrigger={['onBlur', 'onChange']}
                rules={[
                  {
                    required: true,
                    message: t('please-enter-full-name') || ''
                  }
                ]}>
                <Input
                  maxLength={100}
                  preventInput={isAdmin}
                  title="role-name"
                  placeholder="please-enter"
                  required
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item name="description">
                <TextArea
                  title="description"
                  maxLength={255}
                  placeholder={t('interpretation')}
                  showCount
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <HeadTitle style={{ fontWeight: 'bold' }}>
                {t('access-function')}
              </HeadTitle>
              <Col span={24}>
                <StyledCheckBox
                  disabled={isAdmin}
                  checked={checkedAll}
                  onChange={handleCheckAll}>
                  {t('all')}
                </StyledCheckBox>
              </Col>
              <Col offset={1}>
                <Col span={24}>
                  <StyledCheckBox
                    disabled={isAdmin}
                    checked={checkedAllAccountManagement}
                    onChange={handleCheckAllAccountManagement}>
                    {t('account-management')}
                  </StyledCheckBox>
                </Col>
                <Col span={24}>
                  <Form.Item name="account_management">
                    <StyledGroupCheckBox
                      disabled={isAdmin}
                      value={checkedAccountManagement}
                      onChange={handleCheckboxChangeAccountManagement}
                      options={ACCOUNT_MAMAGERMENT_OPTIONS}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <StyledCheckBox
                    disabled={isAdmin}
                    checked={checkedAllCategoryManagement}
                    onChange={handleCheckAllCategoryManagement}>
                    {t('menu-management')}
                  </StyledCheckBox>
                </Col>
                <Col span={24}>
                  <Form.Item name="category_management">
                    <StyledGroupCheckBox
                      value={checkedCategoryManagement}
                      disabled={isAdmin}
                      onChange={handleCheckboxChangeCategoryManagement}
                      options={CATEGORY_MANAGEMENT}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <StyledCheckBox
                    disabled={isAdmin}
                    checked={checkedAllPatientManagement}
                    onChange={handleCheckAllPatientManagement}>
                    {t('patient-management')}
                  </StyledCheckBox>
                </Col>
                <Col span={24}>
                  <Form.Item name="patient_management">
                    <StyledGroupCheckBox
                      disabled={isAdmin}
                      value={checkedPatientManagement}
                      onChange={handleCheckboxChangePatientManagement}
                      options={PATIENT_MAMAGERMENT_OPTIONS}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <StyledCheckBox
                    disabled={isAdmin}
                    checked={checkedAllExamination}
                    onChange={handleCheckAllExamination}>
                    {t('examination')}
                  </StyledCheckBox>
                </Col>
                <Col span={24}>
                  <Form.Item name="examination">
                    <StyledGroupCheckBox
                      disabled={isAdmin}
                      value={checkedExamination}
                      onChange={handleCheckboxChangeExamination}
                      options={EXAMINATION_OPTIONS}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <StyledCheckBox
                    disabled={isAdmin}
                    checked={checkedAllWarehouseManagement}
                    onChange={handleCheckAllWarehouseManagement}>
                    {t('repo-management')}
                  </StyledCheckBox>
                </Col>
                <Col span={24}>
                  <Form.Item name="warehouse_management">
                    <StyledGroupCheckBox
                      disabled={isAdmin}
                      value={checkedExamination}
                      onChange={handleCheckboxChangeWarehouseManagement}
                      options={REPO_MANAGEMENT_OPTIONS}
                    />
                  </Form.Item>
                </Col>
              </Col>
            </Col>
            <StyledTStauts span={24}>
              <Form.Item name="status">
                <Switch title="status" onChange={handleChangeStatus} />
              </Form.Item>
            </StyledTStauts>
          </Row>
        </StyledFormModal>
      </StyledContainer>
      <FooterModal
        onSubmit={handleOnSubmit}
        loading={loading}
        disabled={loading}
      />
    </Disabled>
  )
}

export default AddEditRoleModal
